import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    DESCPRODUTO: 'Descrição 1',
    GRUPO: 'Grupo 1',
    MARCA: 'Marca 1',
    CUSTOAQUISICAO: 'Custo 1',
    PRECOVENDA: 'Preço 1',
  },
  {
    DESCPRODUTO: 'Descrição 2',
    GRUPO: 'Grupo 2',
    MARCA: 'Marca 2',
    CUSTOAQUISICAO: 'Custo 2',
    PRECOVENDA: 'Preço 2',
  },
  {
    DESCPRODUTO: 'Descrição 3',
    GRUPO: 'Grupo 3',
    MARCA: 'Marca 3',
    CUSTOAQUISICAO: 'Custo 3',
    PRECOVENDA: 'Preço 3',
  },
  {
    DESCPRODUTO: 'Descrição 4',
    GRUPO: 'Grupo 4',
    MARCA: 'Marca 4',
    CUSTOAQUISICAO: 'Custo 4',
    PRECOVENDA: 'Preço 4',
  },
]

export default function RelacaoProdutosInativos(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  const filtrarResultados = (props: {
    descproduto: string
    grupo: string
    marca: string
    custoaquisicao: string
    precovenda: string
  }) => {
    data.filter((value) => {
      setSpinning(true)
      const dataFilter = value.DESCPRODUTO === props.descproduto
      console.log(value.DESCPRODUTO === props.descproduto)
      setSpinning(false)
      return dataFilter
    })
  }

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Relação de Produtos Inativos'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Descrição do Produto' dataIndex={'DESCPRODUTO'} />
            <Column title='Grupo' dataIndex={'GRUPO'} />
            <Column title='Marca' dataIndex={'MARCA'} />
            <Column title='Custo Aquisição' dataIndex={'CUSTOAQUISICAO'} />
            <Column title='Preço Venda' dataIndex={'PRECOVENDA'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow' gutter={3}>
          <Col span={allFields.GRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Grupo</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='GRUPO'
              placeholder='Grupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.GRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Grupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='GRUPOESPEC'
                placeholder='Grupo Específico'
              >
                <Option value='Grupo 1'>Grupo 1</Option>
                <Option value='Grupo 2'>Grupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.SUBGRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>SubGrupo</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='SUBGRUPO'
              placeholder='SubGrupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.SUBGRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>SubGrupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='SUBGRUPOESPEC'
                placeholder='SubGrupo Específico'
              >
                <Option value='SubGrupo 1'>SubGrupo 1</Option>
                <Option value='SubGrupo 2'>SubGrupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.MARCA === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Marca</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='MARCA'
              placeholder='Marca'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.MARCA === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Marca Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='MARCAESPEC'
                placeholder='Marca Específica'
              >
                <Option value='Marca 1'>Marca 1</Option>
                <Option value='Marca 2'>Marca 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.CLASSE === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Classe</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='CLASSE'
              placeholder='Classe'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.CLASSE === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Classe Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='CLASSEESPEC'
                placeholder='Classe Específica'
              >
                <Option value='Classe 1'>Classe 1</Option>
                <Option value='Classe 2'>Classe 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    filtrarResultados({
                      descproduto: allFields.AGRUPAMENTO_ESPEC,
                      grupo: allFields.CLIENTE_ESPEC,
                      marca: allFields.DTINICIO,
                      custoaquisicao: allFields.DTFINAL,
                      precovenda: allFields.VALOR,
                    })

                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
